import React, { useEffect, useState } from "react";
import TornaAlMenu from "../components/TornaAlMenu";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function AppNotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const token = localStorage.getItem("access");

  const parseFidelityMessage = (message = "") => {
    const out = {};
    String(message || "").replaceAll("\\n", "\n").split("\n").forEach((line) => {
      const idx = line.indexOf("=");
      if (idx > -1) {
        out[line.slice(0, idx).trim()] = line.slice(idx + 1).trim();
      }
    });
    return out;
  };

  const money = (v) => `€ ${Number(String(v || "0").replace(",", ".")).toFixed(2).replace(".", ",")}`;

  const loadNotifications = async () => {
    setErr("");
    try {
      const res = await fetch(`${API_URL}/api/app/notifications/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json().catch(() => []);
      if (!res.ok) throw new Error(data?.detail || "Errore caricamento notifiche.");
      setNotifications(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e.message || "Errore caricamento notifiche.");
      setNotifications([]);
    } finally {
      setLoading(false);
    }
  };

  const markRead = async (id) => {
    try {
      await fetch(`${API_URL}/api/app/notifications/${id}/read/`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
      loadNotifications();
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    loadNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container py-4">
      <TornaAlMenu />

      <div
        className="rounded-5 p-4 mb-4 text-white"
        style={{
          background: "linear-gradient(135deg, #5b0f1b 0%, #8b1e2d 55%, #211014 100%)",
          boxShadow: "0 18px 40px rgba(91,15,27,0.22)",
        }}
      >
        <div className="small text-uppercase opacity-75 mb-2">App Cliente</div>
        <h1 className="fw-bold mb-2">🔔 Notifiche</h1>
        <p className="mb-0 opacity-75">
          Comunicazioni personali del tuo punto vendita e aggiornamenti importanti.
        </p>
      </div>

      {err && <div className="alert alert-danger rounded-4">{err}</div>}

      {loading ? (
        <div className="alert alert-light rounded-4">Caricamento notifiche...</div>
      ) : notifications.length === 0 ? (
        <div className="alert alert-light rounded-4">
          Non hai notifiche al momento.
        </div>
      ) : (
        <div className="d-flex flex-column gap-3">
            {notifications.map((n) => {
              const fidelity = n.type === "FIDELITY" ? parseFidelityMessage(n.message) : null;

              if (fidelity) {
                const prodotti = String(fidelity.PRODOTTI || "").split(" | ").filter(Boolean);

                return (
                  <div
                    key={n.id}
                    className={`card border-0 rounded-5 shadow-sm overflow-hidden ${n.is_read ? "opacity-75" : ""}`}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
                        <h5 className="fw-bold mb-0">🎉 Punti fedeltà caricati</h5>
                        {!n.is_read && (
                          <span
                            className="badge text-bg-warning rounded-pill"
                            style={{
                              whiteSpace: "nowrap",
                              minWidth: 58,
                              textAlign: "center",
                            }}
                          >
                            Nuova
                          </span>
                        )}
                      </div>

                      <p className="mb-4 text-muted">
                        Hai ricevuto <strong className="text-success">{String(fidelity.PUNTI || "0").replace(".", ",")} punti</strong> fedeltà per il tuo acquisto presso Dallo Zio Roby.
                      </p>

                      <div className="border rounded-4 p-3 mb-3 bg-light">
                        <div className="d-flex justify-content-between gap-3 py-2">
                          <span className="text-muted">Importo acquisto</span>
                          <strong className="text-success">{money(fidelity.IMPORTO)}</strong>
                        </div>

                        <hr className="my-2" />

                        <div className="d-flex justify-content-between gap-3 py-2">
                          <span className="text-muted">Metodo di pagamento</span>
                          <strong className="text-end">{fidelity.METODO || "-"}</strong>
                        </div>

                        <hr className="my-2" />

                        <div className="py-2">
                          <div className="text-muted mb-1">Prodotti acquistati</div>
                          {prodotti.length ? prodotti.map((x, i) => (
                            <div key={i} className="fw-semibold">{x}</div>
                          )) : <div className="fw-semibold">Acquisto in negozio</div>}
                        </div>
                      </div>

                      <div className="text-muted mb-2">
                        Grazie per aver scelto Dallo Zio Roby! Continua così, i tuoi punti ti avvicinano ai prossimi premi. 🎉
                      </div>

                      <div className="small text-muted">
                        {n.created_at ? new Date(n.created_at).toLocaleString() : ""}
                      </div>

                      {!n.is_read && (
                        <button
                          type="button"
                          className="btn btn-outline-success rounded-pill mt-3"
                          onClick={() => markRead(n.id)}
                        >
                          Segna come letta
                        </button>
                      )}
                    </div>
                  </div>
                );
              }

              return (
                <div
                  key={n.id}
                  className={`card border-0 rounded-5 shadow-sm ${n.is_read ? "opacity-75" : ""}`}
                >
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-start gap-3">
                      <div>
                        <h5 className="fw-bold mb-2">{n.title}</h5>
                        <p className="text-muted mb-2" style={{ whiteSpace: "pre-wrap" }}>
                          {String(n.message || "").replaceAll("\\n", "\n")}
                        </p>
                        <div className="small text-muted">
                          {n.created_at ? new Date(n.created_at).toLocaleString() : ""}
                        </div>
                      </div>

                      {!n.is_read && (
                        <span
                          className="badge text-bg-warning rounded-pill"
                          style={{
                            whiteSpace: "nowrap",
                            minWidth: 58,
                            textAlign: "center",
                          }}
                        >
                          Nuova
                        </span>
                      )}
                    </div>

                    {!n.is_read && (
                      <button
                        type="button"
                        className="btn btn-outline-success rounded-pill mt-3"
                        onClick={() => markRead(n.id)}
                      >
                        Segna come letta
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}
